import {Injectable} from '@angular/core';
import {Response, Headers, URLSearchParams, RequestOptions, ResponseContentType} from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map';

@Injectable()
export class ReportJobService {

  private url: string = `${ environment.apiRoot }/report-job/`;

  constructor(private http: HttpAuth) { }

  public getReportJob(offer_id?: string, venue?: string, status?: any[], page?: number, pagecount?: number, premium?:number, query_skill?: string, query_edu?:string, query_exp?:string): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    
    if(offer_id){
        params.append('id',offer_id);
    }
    
    if(query_skill){
        params.append('query_skill',query_skill);
    }
    if(query_edu){
        params.append('query_edu',query_edu);
    }
    if(query_exp){
        params.append('query',query_exp);
    }

    if(venue){
        params.append('venue_id',venue);
    }
    // if(city){
    //     params.set('city',city);
    // }
    if(status){
        status.forEach(function(element, index, array) {
            params.append('status[]', element);
        });
    }

    if(page) {
      params.append('page', String(page));
    }

    if(pagecount) {
      params.append('pagecount', String(pagecount));
    }

    if(premium != undefined) {
      params.append('premium', String(premium));
    }

    params.append('summary','1');

    const options = new RequestOptions({search: params});

    return this.http.get(this.url, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getReportJobWithUpdate(page?: number, pagecount?: number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (page) {
      params.append('page', String(page));
    }

    if (pagecount) {
      params.append('pagecount', String(pagecount));
    }

    params.append('update', String(1));

    const options = new RequestOptions({search: params});

    return this.http.get(this.url, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getReportJobDate(offer_id?: string, venue?: string, status?: any[], page?: number, pagecount?: number, premium?:number, date_start?:string, date_end?:string): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if(offer_id){
        params.append('id',offer_id);
    }
    if(date_start){
      params.append('start_date',date_start);
    }
    if(date_end){
      params.append('end_date',date_end);
    }

    if(venue){
        params.append('venue_id',venue);
    }
    // if(city){
    //     params.set('city',city);
    // }
    if(status){
        status.forEach(function(element, index, array) {
            params.append('status[]', element);
        });
    }

    if(page) {
      params.append('page', String(page));
    }

    if(pagecount) {
      params.append('pagecount', String(pagecount));
    }

    if(premium != undefined) {
      params.append('premium', String(premium));
    }

    params.append('summary','1');

    const options = new RequestOptions({search: params});

    return this.http.get(this.url, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();

    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/report-job.service.ts